import React from "react";
import "./about.css";
import HeadingContainer from "../heading-container/HeadingContainer";
import { Typography } from "@mui/material";

const AboutUs = () => {
  const [aboutData, setAboutData] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/aboutus`)
      .then(res => res.json())
      .then(data => {
        if (data && data.length > 0) {
          setAboutData(data[0].details);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <HeadingContainer title="About Us" />
      <section className="about-section">
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
            <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: '36px', height: '36px', borderRadius: '50%', borderLeftColor: 'var(--primary)', animation: 'spin 1s linear infinite' }}></div>
            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
          </div>
        ) : (
          <div className="about-card hover-scale" style={{ transition: 'transform 0.4s ease' }}>
            <div className="about-content-inner">
              <h2 className="about-heading">
                Our Story <span style={{ fontSize: '2rem' }}>✨</span>
              </h2>
              <Typography variant="body1" className="about-text" style={{ whiteSpace: 'pre-line' }}>
                {aboutData || `We believe that each child is inherently unique in his or her learning capacities and capabilities, so at White Wings, we place a heavy focus on fundamental skills while also striving to identify and meet the specific requirements of each student. We respect the past but know that in the present and future, students need a curriculum that is forward-thinking and contemporary if they are to succeed.

The school's reputation for academic achievement stems from its numerous accolades and great teachers. We believe that the flame of consciousness already lit in each child, and the extent to which it may influence their life if nourished, is just as crucial as a rigorous academic program.`}
              </Typography>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default AboutUs;
